module.exports = __webpack_public_path__ + "img/enviado.0622c2d4.svg";